import { render, staticRenderFns } from "./DashMigracao.vue?vue&type=template&id=566bc031&hidden=true"
import script from "./DashMigracao.vue?vue&type=script&lang=js"
export * from "./DashMigracao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports